import Icon from 'veui/components/Icon'

Icon.register({
  'sort-alt': {
    paths: [
      {
        d: 'M576 320a32 32 0 01-24.31-11.17L384 113.17 216.3 308.83a32 32 0 01-48.6-41.66l192-224a32 32 0 0148.6 0l192 224A32 32 0 01576 320zM384 736a32 32 0 01-24.3-11.17l-192-224a32 32 0 0148.6-41.66L384 654.83l167.7-195.66a32 32 0 0148.6 41.66l-192 224A32 32 0 01384 736z'
      }
    ],
    width: '768',
    height: '768'
  }
})
